import AnimatedGrid from "./AnimatedGrid";

const tags = ["Design", "Comunicação", "Museus", "Centros Interpretativos", "Exposições Temporárias", "Ativação de Marca", "Soluções Interativas"];

const HeroSection = () => {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-20 overflow-hidden section-light"
    >
      <AnimatedGrid />
      <div className="glow-orb w-[480px] h-[480px] bg-accent top-6 left-1/4" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <div className="max-w-3xl">
          <div
            className="opacity-0"
            style={{ animation: "fade-up 0.8s ease-out 0.2s forwards" }}
          >
            <span className="section-label">A nossa abordagem</span>
            <h1 className="section-heading !text-5xl sm:!text-6xl md:!text-7xl lg:!text-8xl">
              Olá,<br />
              somos a <span className="text-accent">EVK</span>
            </h1>
          </div>

          <p
            className="text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl mt-6 sm:mt-8 opacity-0"
            style={{ animation: "fade-up 0.8s ease-out 0.5s forwards" }}
          >
            Trabalhamos de forma integrada, permitindo aos nossos clientes ter
            uma resposta a 360° às suas necessidades de comunicação.
          </p>

          <div
            className="flex flex-wrap gap-2 sm:gap-3 mt-6 sm:mt-8 opacity-0"
            style={{ animation: "fade-up 0.8s ease-out 0.7s forwards" }}
          >
            {tags.map((tag) => (
              <span key={tag} className="tag-pill">
                {tag}
              </span>
            ))}
          </div>

          <div
            className="mt-8 sm:mt-10 opacity-0"
            style={{ animation: "fade-up 0.8s ease-out 0.9s forwards" }}
          >
            <a href="#brands" className="glass-btn inline-flex items-center gap-3 px-8 py-4 text-sm font-medium">
              Conhecer as marcas
              <span className="text-lg" style={{ animation: "bounce-arrow 1.5s ease-in-out infinite" }}>↓</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
